<template>
  <ul
    class="footer-navigation__columns md:hidden"
    role="list"
  >
    <li
      v-for="(group, index) in accordion"
      :key="group.title"
      class="footer-navigation__column"
      :class="{ 'footer-navigation__column--open': group.show }"
    >
      <h2
        class="footer-navigation__column-title md font-semibold normal-case"
      >
        <button
          type="button"
          class="footer-navigation__toggle"
          :aria-expanded="Boolean(group.show)"
          :aria-controls="`footer-links-${instanceId}-${index}`"
          @click="group.show = !group.show"
        >
          {{ group.title }}
          <span
class="plus-icon"
aria-hidden="true"
/>
        </button>
      </h2>
      <Vue3SlideUpDown
        v-model="group.show"
        :duration="accordionDuration"
      >
        <ul
:id="`footer-links-${instanceId}-${index}`"
class="footer-navigation__list"
>
          <li
            v-for="link in group.links"
            :key="link.url"
            class="footer-navigation__list-item"
          >
            <a
              :href="link.url"
              class="footer-navigation__link"
            >
              {{ link.title }}
            </a>
          </li>
        </ul>
      </Vue3SlideUpDown>
    </li>
  </ul>
</template>

<script>
import { Vue3SlideUpDown } from "vue3-slide-up-down"


export default {
  components: {
    Vue3SlideUpDown,
  },
  props: {
    accordionData: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      accordion: [...this.accordionData],
      instanceId: this.$.uid,
      accordionDuration: 300
    }
  },
  computed: {
  },
  mounted () {
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.updateMotion = () => { this.accordionDuration = this.motionQuery.matches ? 0 : 300 }
    this.motionQuery.addEventListener('change', this.updateMotion)
    this.updateMotion()
  },
  beforeUnmount () {
    this.motionQuery?.removeEventListener('change', this.updateMotion)
  },
  methods: {
  }
}
</script>
